import React, { useState, useEffect } from 'react';
import SideBar from '../../../src/Components/ClientDashboard/Clientcommon/SideBar';
import Header from '../../../src/Components/ClientDashboard/Clientcommon/Header';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../../../src/pages/client/client_assets/css/sb-admin-2.min.css';
import '../../../src/pages/client/client_assets/css/common.css';
import '../../../src/pages/client/client_assets/css/responsive.css';
import '../../../src/pages/client/client_assets/css/Configure.css';
import HideText from '../../Components/ClientDashboard/Clientcommon/HidePageText';
import EmployeeForm from '../../Components/ClientDashboard/ClientSurveys/Employee/EmployeeForm';


const EmployeeFormPage = () => 
{

    
    return (
        <div id="page-top">
        <div id="wrapper">
          <SideBar />
          <div id="content-wrapper" className="d-flex flex-column">
            <div id="content" style={{ backgroundColor: '#F5F7F8' }}>
              <Header />
              <EmployeeForm />

            </div>
          </div>
        </div>
        <HideText/>
      </div>
    );
};



export default EmployeeFormPage;